export enum StepOptions {
  Domicile = 'domicile',
  Client = 'client',
  PlansServices = 'plans',
  Billing = 'billing',
  Summary = 'summary',
}
